var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckExtended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4961 54C15.1743 54 5.99609 44.8218 5.99609 33.5C5.99609 22.1782 15.1743 13 26.4961 13C31.453 13 35.999 14.7593 39.5438 17.6876L43.2547 14.2798C38.7732 10.369 32.9113 8 26.4961 8C12.4128 8 0.996094 19.4167 0.996094 33.5C0.996094 47.5833 12.4128 59 26.4961 59C40.5794 59 51.9961 47.5833 51.9961 33.5C51.9961 30.9728 51.6285 28.5314 50.9437 26.2264L46.7168 30.1081C46.9005 31.2114 46.9961 32.3445 46.9961 33.5C46.9961 44.8218 37.8179 54 26.4961 54Z",
    fill: "#009245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9922 30.3333L26.4922 39L54.9922 13",
    stroke: "#009245",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckExtended);
export default __webpack_public_path__ + "static/media/circle-check-extended.8d210f9a6f67c3e2f0516588ba78f622.svg";
export { ForwardRef as ReactComponent };